export default "__VITE_IMAGE_ASSET__d89e9c92__";